<template>
  <pt-notes-detail class="pt-notes-detail__page" :id="id" :signId="signId"></pt-notes-detail>
</template>

<script>
import PtNotesDetail from 'cps/appointment-application/pt-active-sign-notes/pt-notes-detail/withData'
export default {
  name: 'pt-notes-detail__view',
  components: {
    'pt-notes-detail': PtNotesDetail
  },
  props: {
    id: {
      type: String
    },
    signId: {
      type: String
    }
  }
}
</script>
